import { t } from '../../i18n';

interface RateLimitCountdownViewProps {
  remaining: number;
}

export function RateLimitCountdownView({ remaining }: RateLimitCountdownViewProps) {
  const countdownText = t('rateLimitCountdown').replace('{seconds}', String(remaining));

  return (
    <div className="input-bar">
      <div className="rate-limit-countdown">
        <span className="countdown-bot">🤖</span>
        <span className="countdown-text">{countdownText}</span>
      </div>
    </div>
  );
}

interface CaptchaChallengeViewProps {
  question: string;
  captchaInputRef: React.MutableRefObject<HTMLInputElement | null>;
  onSubmit(): void;
}

export function CaptchaChallengeView({
  question,
  captchaInputRef,
  onSubmit,
}: CaptchaChallengeViewProps) {
  return (
    <div className="input-bar">
      <div className="captcha-challenge">
        <span className="captcha-label">{t('captchaPrompt')}</span>
        <span className="captcha-question">{question}</span>
        <input
          ref={(node) => {
            captchaInputRef.current = node;
          }}
          type="number"
          className="captcha-input"
          placeholder="?"
          inputMode="numeric"
          autoComplete="off"
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              onSubmit();
            }
          }}
        />
        <button className="captcha-submit-btn" onClick={onSubmit}>
          {t('captchaVerify')}
        </button>
      </div>
    </div>
  );
}

export function CaptchaLoadingView() {
  return (
    <div className="input-bar">
      <div className="rate-limit-countdown">
        <span className="countdown-bot">🤖</span>
      </div>
    </div>
  );
}
